<template>
    <div class="row">
        <div class="col-12 col-lg-4 order-lg-2">
            <account-sidebar
                :lng="lng"
                :mainlng="mainlng"
                :translations="translations"
                :accountlink="accountlink"
                :logoutlink="logoutlink"
                :isaccountroute="!!isaccountroute"
                :account="localAccount"
                v-on:AvattarChanged="changeAvatar($event)"
            ></account-sidebar>
        </div>
        <div class="col-12 col-lg-8 order-lg-1">
            <notification-alert-block v-for="(notification, key) in preparedNotifications" :notification="notification"
                                      :setnotificationlink="setnotificationlink" :key="key"></notification-alert-block>
            <div class="simple__block">
                <h3 class="h5">{{ get_translation_constant('text_arrived_package_list') }}</h3>
                <table class="table table__arrived__orders">
                    <thead>
                    <tr>
                        <th>
                            <div class="checkbox__custom">
                                <input id="select_all" name="select_all" type="checkbox" v-model="toggleSelect"
                                       @change="toggleAllSelect()">
                                <label for="select_all"></label>
                            </div>
                        </th>
                        <th>{{ get_translation_constant('text_tracking_number') }}</th>
                        <th>{{ get_translation_constant('text_delivery') }}</th>
                        <th>{{ get_translation_constant('text_price') }}</th>
                        <th v-if="account.location_id !== 1">{{ get_translation_constant('text_flight') }}</th>
                        <th>{{ get_translation_constant('text_status') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(order, key) in this.orders">
                        <td>
                            <div class="checkbox__custom">
                                <input class="order__payment_check" :id="'select'+order.id" :name="'select'+order.id"
                                       type="checkbox" v-model="order.checked">
                                <label :for="'select'+order.id"></label>
                            </div>
                        </td>
                        <td><a :href="order.view_link">{{ order.track_code }}</a>
                        </td>
                        <td>
                            <div
                                class="table__extras d-flex justify-content-sm-end justify-content-lg-start align-items-center">
                            <span v-for="(service, key) in order.services"
                                  class="tooltip__block tooltip__top tooltip__block_simple">
                                  <span class="tooltip__block_trigger">
                                     <img :src="service.icon" class="service-image"
                                          :class="checkServiceHasUploads(service, order)" alt="">
                                  </span>
                                   <span class="tooltip__block_inner"><p>{{ service.title }}</p></span>
                            </span>
                                <span v-for="(solution, key) in order.solutions"
                                      class="tooltip__block tooltip__top tooltip__block_simple">
                                  <span class="tooltip__block_trigger">
                                     <img :src="solution.icon" class="service-image" alt="">
                                  </span>
                                   <span class="tooltip__block_inner"><p>{{ solution.title }}</p></span>
                            </span>
                            </div>
                        </td>
                        <td>
                            <strong>{{
                                    (typeof order.total_price !== 'undefined') &&
                                    (order.total_price !== null) &&
                                    (order.total_price > 0)
                                        ? order.total_price + ' $' : '-'
                                }}</strong>
                        </td>
                        <td v-if="account.location_id !== 1">{{ getOrderFlight(order) }}</td>
                        <td>
                            <strong
                                @click="viewOrder(order)"
                                :style="account.location_id !== 1 ? '':'cursor: pointer;'"
                                :class="!!order.paid ? 'color__green' : 'color__red'">{{
                                    !!order.paid ? get_translation_constant('arrived_order_paid_status_name') :
                                        get_translation_constant('arrived_order_not_paid_status_name')
                                }}</strong>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="orderPayment_block" :style="someOrderIsNotPaid? '':'display: none !important;'">
                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="text__small color__red mb-3 mb-md-0">
                            {{ get_translation_constant('text_pay_for_order') }}
                        </div>
                        <div class="d-md-flex align-items-center">
                            <strong class="mr-5 d-block mb-3 mb-md-0">{{ get_translation_constant('text_pay') }}:
                                {{ calculatedOrdersTotalSum }}</strong>
                            <a class="btn btn__large btn__blue d-block" href="#" data-bs-toggle="modal"
                               data-bs-target="#orderPayment">{{ get_translation_constant('text_pay') }}</a>
                        </div>
                    </div>
                </div>
                <div class="orderDelivery_block" :style="someOrderIsPaid? '':'display: none !important;'">
                    <div class="d-md-flex justify-content-end mt-4">
                        <a class="btn btn__large btn__green d-block" href="#" data-bs-toggle="modal"
                           data-bs-target="#orderDelivery">{{ get_translation_constant('text_arrange_delivery') }}</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal order Payment -->
        <div class="modal fade modal__custom" id="orderPayment" tabindex="-1" role="dialog"
             aria-labelledby="orderPaymentTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="orderPaymentTitle">{{
                                get_translation_constant('text_order_payment')
                            }}</h5>
                        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                                id="orderPaymentClose" data-bs-target="#orderPayment"></button>
                    </div>
                    <div class="modal-body">
                        <table class="table table__order_payment">
                            <thead>
                            <tr>
                                <th>
                                    <p><span class="h_text">{{ get_translation_constant('text_bill') }}</span>
                                        {{
                                            orders.filter((order) => {
                                                return (!!order.paid === false) && !!order.checked
                                            }).length
                                        }}
                                        ({{ get_translation_constant('text_one_order') }})</p>
                                </th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(form_order , key) in checkedNotPaidOrders">
                                <td>{{ get_translation_constant('text_order_number') }}{{ form_order.id }}</td>
                                <td>{{
                                        (form_order.total_price !== null) && (typeof form_order.total_price.toFixed(2) !== 'undefined') ? form_order.total_price.toFixed(2) : ''
                                    }} $
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td class="h6 color__black">{{ get_translation_constant('text_total') }}</td>
                                <td>{{ calculatedOrdersTotalSum }}</td>
                            </tr>
                            </tfoot>
                        </table>
                        <div class="form__col form__col_promo_code" :class="hasError('promo_code')">
                            <label for="promo_code">{{ get_translation_constant('text_promo_code') }}</label>
                            <input
                                v-model="promo_code.code"
                                class="form__control"
                                name="promo_code"
                                id="promo_code"
                                :placeholder="get_translation_constant('text_promo_code_placeholder')"
                                @input="clearError('promo_code')"
                            >
                            <div class="form__success" v-if="isValidPromo" v-html="getPromoCodeText">
                            </div>
                            <div class="form__error" v-if="hasErrorMessage('promo_code')">
                                {{ hasErrorMessage('promo_code') }}
                            </div>
                            <!--                            <a class="btn"
                                                           @click.prevent="checkPromoCode">{{ get_translation_constant('text_apply') }}
                                                        </a>-->
                        </div>
                        <form action="">
                            <div class="row align-items-start">
                                <div class="col-12 col-md-8">
                                    <div class="form__col"
                                         :class="hasError('paymentMethod')">
                                        <multiselect v-model="form.paymentMethod"
                                                     class="form-control"
                                                     :multiple="false"
                                                     :placeholder="get_translation_constant('text_choose_method')"
                                                     :options="filteredPaymentMethods"
                                                     label="title"
                                                     selectLabel=""
                                                     deselectLabel=""
                                                     :optionHeight="48"
                                                     :showPointer="true"
                                        >
                                            <template></template>
                                        </multiselect>
                                        <div class="form__error"
                                             v-if="hasErrorMessage('paymentMethod' )">
                                            <template v-if="form.paymentMethod===null">
                                                {{ get_translation_constant('text_insufficient_funds') }}
                                            </template>
                                            <template v-else-if="checkFunds">
                                                {{ get_translation_constant('text_insufficient_funds') }}
                                            </template>
                                            <template v-else> {{
                                                    get_translation_constant('text_field_is_required')
                                                }}
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-md-4">
                                    <div class="form__col">
                                        <input
                                            @click.prevent="pay()"
                                            class="btn btn__large btn__blue btn__block payment__success"
                                            type="submit" :value="get_translation_constant('text_pay')">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal order Delivery -->
        <div class="modal fade modal__custom" id="orderDelivery" tabindex="-1" data-bs-backdrop="static" role="dialog"
             aria-labelledby="orderDeliveryTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="orderDeliveryTitle">
                            {{ get_translation_constant('text_arrange_delivery') }}</h5>
                        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                                id="orderDeliveryClose" @click.prevent="handleCloseShipping()"></button>
                    </div>
                    <div class="modal-body">
                        <table class="table table__order_payment">
                            <thead>
                            <tr>
                                <th>
                                    <p><span class="h_text">{{ get_translation_constant('text_bill') }}</span>
                                        {{
                                            orders.filter((order) => !!order.paid && !!order.checked && (order.shipping_info === null)).length
                                        }}
                                        ({{ get_translation_constant('text_one_order') }})</p>
                                </th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(form_order , key) in checkedPaidNotShippedOrders">
                                <td>{{ get_translation_constant('text_order_number') }}{{ form_order.id }}</td>
                                <td>{{ form_order.total_price.toFixed(2) }} $</td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                            </tr>
                            </tfoot>
                        </table>
                        <form action="">
                            <h5 class="h_text">{{ get_translation_constant('text_choose_delivery_method') }}</h5>

                            <div class="form__col d-none d-md-block">
                                <div class="row no-gutters radio_group__custom">
                                    <div v-for="(method, key ) in deliverymethods"
                                         class="col-12 col-md-4 radio_group__item">
                                        <input :id="method.title" type="radio" @click="setDelivery(method)"
                                               :checked="method.id === form.deliveryMethod.id"
                                               :value="method.id">
                                        <label :for="method.title">{{ method.title }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form__col d-md-none delivery__select">
                                <multiselect v-model="form.deliveryMethod"
                                             class="form-control"
                                             :multiple="false"
                                             :placeholder="get_translation_constant('text_choose_delivery_method')"
                                             :options="deliveryMethodsWithDefault"
                                             label="title"
                                             selectLabel=""
                                             deselectLabel=""
                                             :optionHeight="48"
                                             :showPointer="true"
                                >
                                </multiselect>
                            </div>
                            <template v-for="(method, key ) in deliverymethods">
                                <!--  ukraine-->
                                <template v-if="account.location_id === 1">
                                    <!-- pickup -->
                                    <template v-if="method.shipping_type_id === 1">

                                    </template>
                                    <!--  courier-->
                                    <template v-else-if="method.shipping_type_id === 2">
                                        <div class="delivery__address_block"
                                             v-show="(form.deliveryMethod.id !=='undefined') && (method.id === form.deliveryMethod.id)">
                                            <div class="row">
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('deliveryMethod.city', true)">
                                                        <label>{{
                                                                get_translation_constant('text_city')
                                                            }}<sup>*</sup></label>
                                                        <!-- kiev selected -->
                                                        <multiselect v-model="form.deliveryMethod.city"
                                                                     class="form-control"
                                                                     :multiple="false"
                                                                     :placeholder="get_translation_constant('text_choose_city')"
                                                                     :options="method.cities"
                                                                     label="title"
                                                                     selectLabel=""
                                                                     deselectLabel=""
                                                                     :optionHeight="48"
                                                                     :showPointer="true"
                                                        ></multiselect>
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.city', true)">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col" :class="hasError('deliveryMethod.address')">
                                                        <label>{{
                                                                get_translation_constant('text_delivery_address')
                                                            }}<sup>*</sup></label>
                                                        <input class="form__control" id="address" name="address"
                                                               :placeholder="get_translation_constant('text_enter_address_latin_letters')"
                                                               type="text" v-model="form.deliveryMethod.address">
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.address')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col" :class="hasError('agent')">
                                                        <label>{{
                                                                get_translation_constant('text_choose_agent')
                                                            }}</label>
                                                        <multiselect v-model="form.deliveryMethod.agent"
                                                                     class="form-control"
                                                                     :multiple="false"
                                                                     :placeholder="get_translation_constant('text_choose_agent')"
                                                                     :options="agentList"
                                                                     label="name"
                                                                     selectLabel=""
                                                                     deselectLabel=""
                                                                     :optionHeight="48"
                                                                     :showPointer="true"

                                                        >
                                                            <template slot="singleLabel" slot-scope="{ option }">
                                    <span class="multiselect__single"
                                          :class="(typeof option.id !== 'undefined') && option.id === '' ? 'multiselect__placeholder__active': ''">{{
                                            (typeof option.id !== 'undefined') && option.id === '' ? get_translation_constant('text_delivery_through_agent') : option.name
                                        }}</span></template>
                                                        </multiselect>
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('agent')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('phone_prefix') || hasError('phone_number')">
                                                        <label>{{ get_translation_constant('text_phone') }}</label>
                                                        <div class="phone__block">
                                                            <multiselect v-model="form.phone_prefix"
                                                                         class="form-control"
                                                                         :multiple="false"
                                                                         :placeholder="''"
                                                                         :options="locationPrefixes"
                                                                         label="title"
                                                                         selectLabel=""
                                                                         deselectLabel=""
                                                                         :optionHeight="48"
                                                                         :showPointer="true"
                                                            >
                                                                <template slot="singleLabel" slot-scope="props">
                                                                    <img class="option__image" :src="props.option.image"
                                                                         width="16">
                                                                    <span class="option__title">{{
                                                                            props.option.title
                                                                        }}</span>
                                                                </template>
                                                                <template slot="option" slot-scope="props">
                                                                    <img class="option__image" :src="props.option.image"
                                                                         width="16">
                                                                    <span class="option__title">{{
                                                                            props.option.title
                                                                        }}</span>
                                                                </template>
                                                            </multiselect>
                                                            <input class="form__control type_tel"
                                                                   v-model="form.phone_number"
                                                                   type="tel">
                                                            <div class="form__error"
                                                                 v-if="hasErrorMessage('phone_prefix') || hasError('phone_number')">
                                                                {{ get_translation_constant('text_field_is_required') }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--                                                <div class="col-12">-->
                                                <!--                                                    <p>{{ get_translation_constant('text_estimate_time') }}: <span-->
                                                <!--                                                        class="color__black d-block d-md-inline-block">-->
                                                <!--                                                        {{ estimateText }}-->
                                                <!--                                                    </span>-->
                                                <!--                                                    </p>-->
                                                <!--                                                    <p>{{ get_translation_constant('text_delivery_price') }}: <strong-->
                                                <!--                                                        class="color__dark_blue">{{-->
                                                <!--                                                            (typeof form.deliveryMethod.city !== 'undefined') &&-->
                                                <!--                                                            (form.deliveryMethod.city !== null) ? form.deliveryMethod.city.price-->
                                                <!--                                                                : method.price-->
                                                <!--                                                        }}</strong>-->
                                                <!--                                                    </p>-->
                                                <!--                                                </div>-->
                                            </div>
                                        </div>
                                    </template>
                                    <!-- nova poshta address -->
                                    <template v-else-if="method.shipping_type_id === 3">
                                        <div class="delivery__address_block"
                                             v-show="(form.deliveryMethod.id !=='undefined') && (method.id === form.deliveryMethod.id)">
                                            <div class="row">
                                                <div class="col-12 col-lg-6">


                                                    <div class="form__col"
                                                         :class="hasError('deliveryMethod.first_name')">
                                                        <label>{{
                                                                get_translation_constant('text_your_first_name_ukraine')
                                                            }}<sup>*</sup></label>
                                                        <input class="form__control"
                                                               :placeholder="get_translation_constant('text_first_name_ukraine')"
                                                               type="text" v-model="form.deliveryMethod.first_name"
                                                               ref="novaPoshtaAddressFirstName"
                                                        >
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.first_name')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('deliveryMethod.last_name')">
                                                        <label>{{
                                                                get_translation_constant('text_your_last_name_ukraine')
                                                            }}<sup>*</sup></label>
                                                        <input class="form__control"
                                                               :placeholder="get_translation_constant('text_last_name_ukraine')"
                                                               type="text" v-model="form.deliveryMethod.last_name"
                                                               ref="novaPoshtaAddressLastName"
                                                        >
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.last_name')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('deliveryMethod.middle_name')">
                                                        <label>{{
                                                                get_translation_constant('text_your_middle_name_ukraine')
                                                            }}<sup>*</sup></label>
                                                        <input class="form__control"
                                                               :placeholder="get_translation_constant('text_middle_name_ukraine')"
                                                               type="text" v-model="form.deliveryMethod.middle_name"
                                                               ref="novaPoshtaAddressMiddleName"
                                                        >
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.middle_name')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('deliveryMethod.text_your_city')">
                                                        <label>{{
                                                                get_translation_constant('text_your_city')
                                                            }}</label>
                                                        <multiselect v-model="form.deliveryMethod.novaPoshta.city"
                                                                     class="form-control"
                                                                     :multiple="false"
                                                                     :placeholder="get_translation_constant('text_enter_street_in_ukraine_letters')"
                                                                     :options="form.deliveryMethod.novaPoshta.cities"
                                                                     label="Description"
                                                                     selectLabel=""
                                                                     deselectLabel=""
                                                                     :optionHeight="48"
                                                                     :showPointer="true"
                                                                     @search-change="asyncCities"
                                                                     @select="loadStreetsOrWarehouses"
                                                        >
                                                        </multiselect>
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.novaPoshta.street')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('deliveryMethod.novaPoshta.street')">
                                                        <label>{{
                                                                get_translation_constant('text_delivery_street')
                                                            }}</label>
                                                        <multiselect v-model="form.deliveryMethod.novaPoshta.street"
                                                                     class="form-control"
                                                                     :multiple="false"
                                                                     :placeholder="get_translation_constant('text_enter_street_in_ukraine_letters')"
                                                                     :options="form.deliveryMethod.novaPoshta.streets"
                                                                     label="Description"
                                                                     selectLabel=""
                                                                     deselectLabel=""
                                                                     :optionHeight="48"
                                                                     :showPointer="true"
                                                                     @search-change="searchTimeOut"
                                                        >
                                                        </multiselect>
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.novaPoshta.street')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('deliveryMethod.novaPoshta.house')">
                                                        <label>{{
                                                                get_translation_constant('text_choose_house')
                                                            }}<sup>*</sup></label>
                                                        <input class="form__control"
                                                               :placeholder="get_translation_constant('text_house')"
                                                               type="text"
                                                               v-model="form.deliveryMethod.novaPoshta.house"
                                                        >
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.novaPoshta.house')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('deliveryMethod.novaPoshta.flat')">
                                                        <label>{{
                                                                get_translation_constant('text_choose_house')
                                                            }}</label>
                                                        <input class="form__control"
                                                               :placeholder="get_translation_constant('text_flat')"
                                                               type="text" v-model="form.deliveryMethod.novaPoshta.flat"
                                                        >
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.novaPoshta.flat')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col" :class="hasError('agent')">
                                                        <label>{{
                                                                get_translation_constant('text_recipient')
                                                            }}</label>
                                                        <multiselect v-model="form.deliveryMethod.agent"
                                                                     class="form-control"
                                                                     :multiple="false"
                                                                     :placeholder="get_translation_constant('text_choose_agent')"
                                                                     :options="agentList"
                                                                     label="name"
                                                                     selectLabel=""
                                                                     deselectLabel=""
                                                                     :optionHeight="48"
                                                                     :showPointer="true"
                                                                     @select="updateNames"

                                                        >
                                                            <template slot="singleLabel" slot-scope="{ option }">
                                    <span class="multiselect__single"
                                          :class="(typeof option.id !== 'undefined') && option.id === '' ? 'multiselect__placeholder__active': ''">{{
                                            (typeof option.id !== 'undefined') && option.id === '' ? get_translation_constant('text_delivery_through_agent') : option.name
                                        }}</span></template>
                                                        </multiselect>
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('agent')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('phone_prefix') || hasError('phone_number')">
                                                        <label>{{ get_translation_constant('text_phone') }}</label>
                                                        <div class="phone__block">
                                                            <multiselect v-model="form.phone_prefix"
                                                                         class="form-control"
                                                                         :multiple="false"
                                                                         :placeholder="''"
                                                                         :options="locationPrefixes"
                                                                         label="title"
                                                                         selectLabel=""
                                                                         deselectLabel=""
                                                                         :optionHeight="48"
                                                                         :showPointer="true"
                                                            >
                                                                <template slot="singleLabel" slot-scope="props">
                                                                    <img class="option__image" :src="props.option.image"
                                                                         width="16">
                                                                    <span class="option__title">{{
                                                                            props.option.title
                                                                        }}</span>
                                                                </template>
                                                                <template slot="option" slot-scope="props">
                                                                    <img class="option__image" :src="props.option.image"
                                                                         width="16">
                                                                    <span class="option__title">{{
                                                                            props.option.title
                                                                        }}</span>
                                                                </template>
                                                            </multiselect>
                                                            <input class="form__control type_tel"
                                                                   v-model="form.phone_number"
                                                                   type="tel">
                                                            <div class="form__error"
                                                                 v-if="hasErrorMessage('phone_prefix') || hasError('phone_number')">
                                                                {{ get_translation_constant('text_field_is_required') }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <!-- nova poshta branch -->
                                    <template v-else-if="method.shipping_type_id === 4">
                                        <div class="delivery__address_block"
                                             v-show="(form.deliveryMethod.id !=='undefined') && (method.id === form.deliveryMethod.id)">
                                            <div class="row">
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('deliveryMethod.first_name')">
                                                        <label>{{
                                                                get_translation_constant('text_your_first_name_ukraine')
                                                            }}<sup>*</sup></label>
                                                        <input class="form__control"
                                                               :placeholder="get_translation_constant('text_first_name_ukraine')"
                                                               type="text" v-model="form.deliveryMethod.first_name"
                                                               ref="novaPoshtaAddressFirstName"
                                                        >
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.first_name')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('deliveryMethod.last_name')">
                                                        <label>{{
                                                                get_translation_constant('text_your_last_name_ukraine')
                                                            }}<sup>*</sup></label>
                                                        <input class="form__control"
                                                               :placeholder="get_translation_constant('text_last_name_ukraine')"
                                                               type="text" v-model="form.deliveryMethod.last_name"
                                                               ref="novaPoshtaAddressLastName"
                                                        >
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.last_name')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('deliveryMethod.middle_name')">
                                                        <label>{{
                                                                get_translation_constant('text_your_middle_name_ukraine')
                                                            }}<sup>*</sup></label>
                                                        <input class="form__control"
                                                               :placeholder="get_translation_constant('text_middle_name_ukraine')"
                                                               type="text" v-model="form.deliveryMethod.middle_name"
                                                               ref="novaPoshtaAddressMiddleName"
                                                        >
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.middle_name')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('deliveryMethod.text_your_city')">
                                                        <label>{{
                                                                get_translation_constant('text_your_city')
                                                            }}</label>
                                                        <multiselect v-model="form.deliveryMethod.novaPoshta.city"
                                                                     class="form-control"
                                                                     :multiple="false"
                                                                     :placeholder="get_translation_constant('text_enter_street_in_ukraine_letters')"
                                                                     :options="form.deliveryMethod.novaPoshta.cities"
                                                                     label="Description"
                                                                     selectLabel=""
                                                                     deselectLabel=""
                                                                     :optionHeight="48"
                                                                     :showPointer="true"
                                                                     @search-change="asyncCities"
                                                                     @select="loadStreetsOrWarehouses"
                                                        >
                                                        </multiselect>
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.novaPoshta.street')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('deliveryMethod.novaPoshta.warehouse')">
                                                        <label>{{
                                                                get_translation_constant('text_delivery_warehouse')
                                                            }}</label>
                                                        <multiselect v-model="form.deliveryMethod.novaPoshta.warehouse"
                                                                     class="form-control"
                                                                     :multiple="false"
                                                                     :placeholder="get_translation_constant('text_enter_warehouse_in_ukraine_letters')"
                                                                     :options="warehouseList"
                                                                     label="Description"
                                                                     selectLabel=""
                                                                     deselectLabel=""
                                                                     :optionHeight="48"
                                                                     :showPointer="true"
                                                                     @search-change="searchTimeOutWarehouse"
                                                        >
                                                        </multiselect>
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('deliveryMethod.novaPoshta.warehouse')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col" :class="hasError('agent')">
                                                        <label>{{
                                                                get_translation_constant('text_recipient')
                                                            }}</label>
                                                        <multiselect v-model="form.deliveryMethod.agent"
                                                                     class="form-control"
                                                                     :multiple="false"
                                                                     :placeholder="get_translation_constant('text_choose_agent')"
                                                                     :options="agentList"
                                                                     label="name"
                                                                     selectLabel=""
                                                                     deselectLabel=""
                                                                     :optionHeight="48"
                                                                     :showPointer="true"
                                                        >
                                                            <template slot="singleLabel" slot-scope="{ option }">
                                    <span class="multiselect__single"
                                          :class="(typeof option.id !== 'undefined') && option.id === '' ? 'multiselect__placeholder__active': ''">{{
                                            (typeof option.id !== 'undefined') && option.id === '' ? get_translation_constant('text_delivery_through_agent') : option.name
                                        }}</span>
                                                            </template>
                                                        </multiselect>
                                                        <div class="form__error"
                                                             v-if="hasErrorMessage('agent')">
                                                            {{ get_translation_constant('text_field_is_required') }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12 col-lg-6">
                                                    <div class="form__col"
                                                         :class="hasError('phone_prefix') || hasError('phone_number')">
                                                        <label>{{ get_translation_constant('text_phone') }}</label>
                                                        <div class="phone__block">
                                                            <multiselect v-model="form.phone_prefix"
                                                                         class="form-control"
                                                                         :multiple="false"
                                                                         :placeholder="''"
                                                                         :options="locationPrefixes"
                                                                         label="title"
                                                                         selectLabel=""
                                                                         deselectLabel=""
                                                                         :optionHeight="48"
                                                                         :showPointer="true"
                                                            >
                                                                <template slot="singleLabel" slot-scope="props">
                                                                    <img class="option__image" :src="props.option.image"
                                                                         width="16">
                                                                    <span class="option__title">{{
                                                                            props.option.title
                                                                        }}</span>
                                                                </template>
                                                                <template slot="option" slot-scope="props">
                                                                    <img class="option__image" :src="props.option.image"
                                                                         width="16">
                                                                    <span class="option__title">{{
                                                                            props.option.title
                                                                        }}</span>
                                                                </template>
                                                            </multiselect>
                                                            <input class="form__control type_tel"
                                                                   v-model="form.phone_number"
                                                                   type="tel">
                                                            <div class="form__error"
                                                                 v-if="hasErrorMessage('phone_prefix') || hasError('phone_number')">
                                                                {{ get_translation_constant('text_field_is_required') }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                                <!--  moldova-->
                                <template v-else-if="account.location_id === 2">

                                    <!-- pickup -->
                                    <template v-if="method.shipping_type_id === 1">

                                    </template>
                                    <!--  courier-->
                                    <template v-else-if="method.shipping_type_id === 2">

                                    </template>

                                </template>
                                <!--  AZERBAIJAN-->
                                <template v-else-if="account.location_id === 3">
                                    <!-- pickup -->
                                    <template v-if="method.shipping_type_id === 1">

                                    </template>
                                    <!--  courier-->
                                    <template v-else-if="method.shipping_type_id === 2">

                                    </template>
                                </template>
                                <!--  BOSNIA-->
                                <template v-else-if="account.location_id === 4">
                                    <!-- pickup -->
                                    <template v-if="method.shipping_type_id === 1">

                                    </template>
                                    <!--  courier-->
                                    <template v-else-if="method.shipping_type_id === 2">

                                    </template>
                                </template>
                            </template>
                            <div class="form__col form__col_collapse">
                                <label class="collapsed" data-bs-toggle="collapse" href="#collapseComment"
                                       role="button" aria-expanded="true" aria-controls="collapseComment">
                                    {{ get_translation_constant('text_comments') }}</label>
                                <div class="collapse show" id="collapseComment">
                                    <div class="card card-body">
                                            <textarea rows="3" class="form__control"
                                                      v-model="form.deliveryMethod.comment"
                                                      type="text"
                                                      :placeholder="get_translation_constant('text_comment')+'...'">
                                            </textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="form__col " :style="hasError('shippingMethodCostError')">
                                <div class="form__error" v-if="hasErrorMessage('shippingMethodCostError' )">
                                    {{ get_translation_constant('text_insufficient_funds') }}
                                </div>
                            </div>
                            <div class="d-md-flex justify-content-end mb-4">
                                <input type="submit" class="btn btn__large btn__green delivery__success d-block"
                                       @click.prevent="submitDelivery"
                                       :value="get_translation_constant('text_arrange_delivery')"
                                       :disabled="!deliveryValidated">
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal order Payment Success -->
        <alert-modal :modalId="modalId" :title="modalTitle" :type="modalType" :message="modalMessage" :promos="promos"
                     :translations="translations" :lng="lng">
        </alert-modal>
    </div>
</template>

<script>
import {debounce} from "lodash";

require('bootstrap-autocomplete');
export default {
    name: "ArrivedOrdersPage",
    props: {
        account: {
            type: [Object]
        },
        translations: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
        isaccountroute: {
            type: [Boolean],
            default: false
        },
        accountlink: {
            type: [String]
        },
        logoutlink: {
            type: [String]
        },
        locations: {
            type: [Object, Array]
        },
        savedeliverylink: {
            type: [String]
        },
        dopaymentlink: {
            type: [String]
        },
        deliverymethods: {
            type: [Object, Array],
            default: () => []
        },
        paymentmethods: {
            type: [Object, Array],
            default: () => []
        },
        setnotificationlink: {
            type: [String]
        },
        promocodecheckurl: {
            type: [String]
        },
        presavedeliverylink: {
            type: [String]
        },
        novaposhtacitysearchlink: {
            type: [String]
        },
        novaposhtastreetsearchlink: {
            type: [String]
        },
        novaposhtawarehousessearchlink: {
            type: [String]
        }
    },
    data() {
        return {
            errors: [],
            form: {
                paymentMethod: null,
                deliveryMethod: {
                    id: '',
                    pre_save: false,
                    comment: '',
                    first_name: this.account.location_id === 1 ? this.account.first_name : this.account.first_name_latin,
                    last_name: this.account.location_id === 1 ? this.account.last_name : this.account.last_name_latin,
                    middle_name: this.account.patronymic,
                    phone: this.account.phone_prefix + this.account.phone_number,
                    phone_prefix: this.account.phone_prefix,
                    phone_number: this.account.phone_number,
                    address: null,
                    city: null,
                    agent: null,
                    department: 'Kyiv 20',
                    novaPoshta: {
                        city: '',
                        cities: [],
                        street: '',
                        house: '',
                        flat: '',
                        branch: '',
                        streets: [],
                        warehouses: [],
                        warehouse: ''
                    },
                },
                orders: [],
                phone_prefix: this.account.phone_prefix,
                phone_number: this.account.phone_number,
                agent: null,
                comment: '',
                shipping_info: ''
            },
            modal: {
                type: 'success',
                title: '',
                message: '',
                id: 'ArrivedOrderPage'
            },
            orders: [],
            trigger: {
                successPayment: false,
                successDelivery: false
            },
            agents: [],
            locationPrefixes: [],
            toggleSelect: false,
            localAccount: {},
            promo_code: {
                code: '',
                text: ''
            },
            isValidPromo: false,
            promos: [],
            orderShippingModal: '',
            novaPoshta: [],
            timer: null,
            searchChange: false
        }
    },
    methods: {
        viewOrder(order){
            //if ukraine
            if (this.account.location_id === 1){
                window.location.href = order.view_link;
            }
        },
        hasError(error, deep = false, level = 1) {
            if (deep) {
                if (level === 1) {
                    let split = error.split('.');
                    if (typeof this.errors[split[0]] !== 'undefined' && typeof this.errors[split[0]][split[1]] !== 'undefined')
                        return 'has__error';
                }
                if (level === 2) {
                    let split = error.split('.');
                    if (typeof this.errors[split[0]] !== 'undefined' && typeof this.errors[split[0]][split[1]] !== 'undefined' && typeof this.errors[split[0]][split[1]][split[2]] !== 'undefined')
                        return 'has__error';
                }
            }
            if (this.errors[error])
                return 'has__error';
        },
        hasErrorMessage(error, deep = false, level = 1) {

            if (deep) {
                if (level === 1) {
                    let split = error.split('.');
                    if (typeof this.errors[split[0]] !== 'undefined' && typeof this.errors[split[0]][split[1]] !== 'undefined')
                        return this.errors[error][0];
                }
                if (level === 2) {
                    let split = error.split('.');
                    if (typeof this.errors[split[0]] !== 'undefined' && typeof this.errors[split[0]][split[1]] !== 'undefined' && typeof this.errors[split[0]][split[1]][split[2]] !== 'undefined')
                        return this.errors[error][0];
                }
            }

            if (this.errors[error])
                return this.errors[error][0];
        },
        clearError(fieled) {
            delete this.errors[fieled];
        },
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },
        changeAvatar(data) {
            console.log(data)
        },
        getOrderFlight(order) {
            return order?.flight?.title;
        },
        getOrderPrice(order) {
            return order?.flight?.title;
        },
        pay() {
            this.promos = [];
            let sum = 0;

            //prepare orders
            this.form.orders = this.orders.filter((order) => {
                return (!!order.paid === false) && !!order.checked
            })

            //check if you can find orders paying
            if (this.form.orders.length === 0) {
                return false
            }
            //calc sum
            this.form.orders.map((order) => {
                sum += order.total_price;
            })
            //check if selected payment
            if (this.form.paymentMethod === null) {
                this.errors = {paymentMethod: ["error"]};
                return false
            }
            //check for balance
            if ((this.form.paymentMethod.payment_type.id === 1) && (this.account.balance < sum)) {
                return false
            }
            //check for bonus
            if ((this.form.paymentMethod.payment_type.id === 2) && (this.account.bonus < sum)) {
                return this.account.bonus < sum;
            }

            let payment = {
                parcel_id: this.form.orders.map((order) => {
                    return order.id;
                }),
                paymentMethod: this.form.paymentMethod,
                promo_code: this.promo_code.code

            }
            axios.post(this.dopaymentlink, payment).then(response => {
                if (response.status === 200) {
                    //clear form
                    this.modal.title = this.get_translation_constant('text_success_add_payment_title');
                    this.modal.type = 'success';
                    this.modal.message = this.get_translation_constant('text_success_add_payment_message');
                    response.data.account.parcel_accepted_promo_codes.map((value, key) => {
                        this.promos.push(value)
                    })

                    this.trigger.successPayment = true;

                    //add paid=true, checked = false to orders and reset form
                    this.orders = this.orders.map((order) => {
                        if (this.form.orders.some((form_order) => {
                            return form_order.id === order.id
                        })) {
                            order.paid = true
                        }
                        return order;
                    }).map((order) => {
                        order.checked = false;
                        return order;
                    });
                    this.errors = [];
                    this.form.orders = [];

                    if (this.form.paymentMethod.payment_type.id === 1) {
                        //update balance
                        this.localAccount.balance = (parseFloat(this.localAccount.balance) - parseFloat(sum)).toFixed(2);
                    }
                    //check for bonus
                    if (this.form.paymentMethod.payment_type.id === 2) {
                        //update balance
                        this.localAccount.bonus = (parseFloat(this.localAccount.bonus) - parseFloat(sum)).toFixed(2);
                    }
                    this.localAccount.orders_for_amount = (parseFloat(this.localAccount.orders_for_amount) + parseFloat(sum)).toFixed(2)


                    setTimeout(() => {
                        document.getElementById('orderPaymentClose').click()
                        this.form.paymentMethod = null
                    }, 200)

                    //TODO emit update balance or bonus
                }
            }).catch(error => {

                if (typeof error.response.status !== 'undefined') {
                    if (error.response.status === 422) {

                        this.errors = error.response.data.errors;
                        this.trigger.successPayment = false;
                        this.form.orders = [];
                        /* this.modal.title = 'Error Add message';
                         this.modal.type = 'error';
                         this.modal.message = 'Error Add message'
                         setTimeout(() => {
                              this.alertModal.click();
                         }, 200) */
                    }
                    if (error.response.status === 500) {

                        this.errors = error.response.data.errors;
                        this.modal.title = this.get_translation_constant('text_error_add_payment_title');
                        this.modal.type = 'error';
                        this.modal.message = this.get_translation_constant('text_error_add_payment_message');
                        this.trigger.successPayment = false;
                        this.form.orders = [];
                        setTimeout(() => {
                            document.getElementById('AlertModalBtn' + this.modal.id).click();
                        }, 200)
                    }
                }

            });
        },
        setDelivery(method) {

            this.form.deliveryMethod.id = method.id;
            this.form.deliveryMethod.title = method.title;
            this.form.deliveryMethod.pre_save = method.pre_save;
            this.form.deliveryMethod.shipping_type_id = method.shipping_type_id;
            //UKRAINE
            if (this.account.location_id === 1) {
                //pickup
                if (method.shipping_type_id === 1) {

                }
                //courier
                if (method.shipping_type_id === 2) {
                    this.form.deliveryMethod.city = method.cities[0];
                    this.form.deliveryMethod.address = this.account.address;
                    this.form.deliveryMethod.phone_number = this.account.phone_number;
                    if (method.pre_save) {

                        //if more then one order selected and paid,  no load presets
                        if (this.orders.filter((order) => (!!order.paid && !!order.checked)).length === 1) {

                            let order = this.orders.find((order) => (!!order.paid && !!order.checked && (order.shipping_method !== null)))
                            //restore presets
                            if (typeof order !== 'undefined') {
                                const data = JSON.parse(order.shipping_info)
                                this.form.deliveryMethod.city = data.deliveryMethod.city ?? null
                                this.form.deliveryMethod.phone = data.deliveryMethod.phone ?? ''
                                this.form.deliveryMethod.phone_prefix = data.deliveryMethod.phone_prefix ?? ''
                                this.form.deliveryMethod.phone_number = data.deliveryMethod.phone_number ?? ''
                                this.form.deliveryMethod.comment = order.shipping_method?.comment;
                                this.form.deliveryMethod.agent = data.deliveryMethod.agent
                            }
                        }
                    }

                }
                //nova poshta address
                if (method.shipping_type_id === 3) {
                    // this.handleNovaPoshtaRef('novaPoshtaAddressFirstName', 'first_name');
                    // this.handleNovaPoshtaRef('novaPoshtaAddressLastName', 'last_name');
                    // this.handleNovaPoshtaRef('novaPoshtaAddressMiddleName', 'middle_name');
                    if (method.pre_save) {

                        //if more then one order selected and paid,  no load presets
                        if (this.orders.filter((order) => (!!order.paid && !!order.checked)).length === 1) {

                            let order = this.orders.find((order) => (!!order.paid && !!order.checked && (order.shipping_method !== null)))
                            //restore presets
                            if (typeof order !== 'undefined') {
                                console.log(order)
                                const data = JSON.parse(order.shipping_info)
                                this.form.deliveryMethod.first_name = data.deliveryMethod.first_name ?? ''
                                this.form.deliveryMethod.middle_name = data.deliveryMethod.middle_name ?? ''
                                this.form.deliveryMethod.last_name = data.deliveryMethod.last_name ?? ''
                                this.form.deliveryMethod.novaPoshta.city = data.deliveryMethod.novaPoshta.city ?? {
                                    id: '',
                                    text: ''
                                }
                                this.form.deliveryMethod.novaPoshta.street = data.deliveryMethod.novaPoshta.street ?? ''
                                this.form.deliveryMethod.novaPoshta.house = data.deliveryMethod.novaPoshta.house ?? ''
                                this.form.deliveryMethod.novaPoshta.flat = data.deliveryMethod.novaPoshta.flat ?? ''
                                this.form.deliveryMethod.phone = data.deliveryMethod.phone ?? ''
                                this.form.deliveryMethod.phone_prefix = data.deliveryMethod.phone_prefix ?? ''
                                this.form.deliveryMethod.phone_number = data.deliveryMethod.phone_number ?? ''
                                this.form.deliveryMethod.comment = order.shipping_method?.comment;
                            }
                        }
                    }
                }
                //nova poshta department
                if (method.shipping_type_id === 4) {
                    if (method.pre_save) {

                        //if more then one order selected and paid,  no load presets
                        if (this.orders.filter((order) => (!!order.paid && !!order.checked)).length === 1) {

                            let order = this.orders.find((order) => (!!order.paid && !!order.checked && (order.shipping_method !== null)))
                            //restore presets
                            if (typeof order !== 'undefined') {
                                const data = JSON.parse(order.shipping_info)
                                this.form.deliveryMethod.first_name = data.deliveryMethod.first_name ?? ''
                                this.form.deliveryMethod.middle_name = data.deliveryMethod.middle_name ?? ''
                                this.form.deliveryMethod.last_name = data.deliveryMethod.last_name ?? ''

                                this.form.deliveryMethod.novaPoshta.city = data.deliveryMethod.novaPoshta.city ?? {
                                    id: '',
                                    text: ''
                                }
                                this.form.deliveryMethod.novaPoshta.warehouse = data.deliveryMethod.novaPoshta.warehouse ?? ''
                                this.form.deliveryMethod.phone = data.deliveryMethod.phone ?? ''
                                this.form.deliveryMethod.phone_prefix = data.deliveryMethod.phone_prefix ?? ''
                                this.form.deliveryMethod.phone_number = data.deliveryMethod.phone_number ?? ''
                                this.form.deliveryMethod.comment = order.shipping_method?.comment;
                            }
                        }
                    }
                }

            }
            //MOLDOVA
            if (this.account.location_id === 2) {
                //pickup
                if (method.shipping_type_id === 1) {

                }
                //courier
                if (method.shipping_type_id === 2) {

                }

            }
            //AZERBAIJAN
            if (this.account.location_id === 1) {
                //pickup
                if (method.shipping_type_id === 1) {

                }
                //courier
                if (method.shipping_type_id === 2) {

                }

            }
            //BOSNIA
            if (this.account.location_id === 4) {
                //pickup
                if (method.shipping_type_id === 1) {

                }
                //courier
                if (method.shipping_type_id === 2) {

                }
            }
        },
        submitDelivery() {

            let method = this.deliverymethods.find(item => item.id === this.form.deliveryMethod.id);
            let shippingCost = 0;

            if (typeof method !== 'undefined') {

                this.form.orders = this.orders.filter((order) => !!order.paid && !!order.checked && ((order.shipping_method === null) || (order.shipping_method.pre_save)));

                if (this.form.orders.length === 0) {
                    return false
                }
                //cost validation
                /*
                if ((method.cities.length > 0) && (typeof method.city !== 'undefined') && (method.city !== null)) {
                    if (isNaN(parseFloat(method.city.price)) || isNaN(parseFloat(method.price))) {
                        return false
                    }
                    shippingCost = parseFloat(method.city.price) > parseFloat(method.price) ?
                        parseFloat(method.city.price).toFixed(2) : parseFloat(method.price).toFixed(2)
                }

                if (this.account.balance < shippingCost) {
                    this.errors['shippingMethodCostError'] = ['error'];
                    return false
                }
                */
                let delivery = {
                    parcel_id: this.form.orders.map((order) => {
                        return order.id
                    }),
                    agent: this.form.deliveryMethod.agent,
                    deliveryMethod: this.form.deliveryMethod,
                    phone_number: this.form.phone_number,
                    phone_prefix: this.form.phone_prefix,
                    comment: this.form.comment
                }

                axios.post(this.savedeliverylink, delivery).then(response => {
                    //TODO handle close window
                    console.log(response)
                    this.orderShippingModal.modal('hide');


                    setTimeout(() => {
                        console.log('success delivery!')
                        document.getElementById('orderDeliveryClose').click();
                    }, 200)
                    if (response.status === 200) {


                    }

                    //clear form
                    this.modal.title = this.get_translation_constant('text_success_add_delivery_title');
                    this.modal.type = 'success';
                    this.modal.message = this.get_translation_constant('text_success_add_delivery_message');
                    this.trigger.successDelivery = true;
                    this.form.deliveryMethod = {
                        id: '',
                        pre_save: false,
                        comment: '',
                        first_name: this.account.first_name_latin,
                        last_name: this.account.last_name_latin,
                        middle_name: this.account.patronymic,
                        phone: this.account.phone_prefix + this.account.phone_number,
                        phone_prefix: this.account.phone_prefix,
                        phone_number: this.account.phone_number,
                        address: null,
                        city: null,
                        agent: null,
                        department: 'Kyiv 20',
                        novaPoshta: {
                            city: {
                                id: '',
                                text: ''
                            },
                            street: '',
                            house: '',
                            flat: '',
                            branch: '',
                            streets: [],
                            warehouses: [],
                            warehouse: ''
                        },
                    }
                    this.orders = this.orders.map((order) => {
                        if (this.form.orders.some((form_order) => {
                            return form_order.id === order.id
                        })) {
                            order.shipping_info = delivery;
                        }
                        return order;
                    }).map((order) => {
                        order.checked = false;
                        return order;
                    });
                    this.errors = [];
                    this.form.orders = [];


                }).catch(error => {
                    if ((typeof error !== 'undefined') && (error !== null) && (error !== '') && (typeof error.response !== 'undefined') && (typeof error.response.status !== 'undefined')) {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.form.orders = [];
                            /*
                                this.modal.title = 'Error Add message';
                                this.modal.type = 'error';
                                this.modal.message = 'Error Add message'
                                setTimeout(() => {
                                     this.alertModal.click();
                                }, 200)
                            */
                        }
                        if (error.response.status === 500) {
                            this.errors = error.response.data.errors;
                            this.modal.title = this.get_translation_constant('text_error_add_delivery_title');
                            this.modal.type = 'error';
                            this.modal.message = this.get_translation_constant('text_error_add_delivery_message');
                            this.trigger.successDelivery = false;
                            this.form.orders = [];
                            document.getElementById('orderDeliveryTrigger').click();
                            setTimeout(() => {
                                document.getElementById('AlertModalBtn' + this.modal.id).click();
                            }, 200)
                        }
                    }
                });

            }
        },
        preSaveDelivery() {

            let method = this.deliverymethods.find(item => item.id === this.form.deliveryMethod.id);
            if (typeof method !== 'undefined') {
                //TODO replace with parcelShippingMethod
                this.form.orders = this.orders.filter((order) => !!order.paid && !!order.checked && ((order.shipping_method === null) || (order.shipping_method.pre_save)));

                if (this.form.orders.length === 0) {
                    return false
                }
                let delivery = {
                    parcel_id: this.form.orders.map((order) => {
                        return order.id
                    }),
                    deliveryMethod: this.form.deliveryMethod,
                }

                axios.post(this.presavedeliverylink, delivery).then(response => {
                    if (response.status === 200) {

                    }
                }).catch(error => {
                    if ((typeof error !== 'undefined') && (error !== null) && (error !== '') && typeof error.response.status !== 'undefined') {
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                        }
                        if (error.response.status === 500) {

                        }
                    }
                });

            }
        },
        initModals() {

            const alertModal = document.getElementById('AlertModalBtn' + this.modal.id);

            const orderPaymentModal = document.getElementById('orderPayment');
            this.orderShippingModal = jQuery('#orderDelivery');

            orderPaymentModal.addEventListener('hidden.bs.modal', () => {

                if (this.trigger.successPayment) {
                    setTimeout(() => {

                        alertModal.click()
                    }, 500)
                    this.trigger.successPayment = false;

                }
                if (this.trigger.successDelivery) {
                    setTimeout(() => {

                        alertModal.click()
                    }, 500)
                    this.trigger.successDelivery = false;
                }
            })
            this.orderShippingModal.on('hidden.bs.modal', () => {
                if (this.trigger.successPayment) {
                    setTimeout(() => {

                        alertModal.click()
                    }, 500)
                    this.trigger.successPayment = false;
                    console.log('hidden successPayment 2')
                }
                if (this.trigger.successDelivery) {
                    setTimeout(() => {

                        alertModal.click()
                    }, 500)
                    this.trigger.successDelivery = false;
                }
            }).on('show.bs.modal', () => {

                if (this.orders.filter((order) => (!!order.paid === true) && !!order.checked && ((order.shipping_info !== null) || ((order.shipping_method !== null) && (order.shipping_method.pre_save)))).length === 1) {
                    let order = this.orders.find((order) => (!!order.paid === true) && !!order.checked && ((order.shipping_info !== null) || ((order.shipping_method !== null) && (order.shipping_method.pre_save))))
                    if (typeof order !== 'undefined') {
                        let method = this.deliverymethods.find(deliveryMethod => deliveryMethod.id === JSON.parse(order.shipping_info).deliveryMethod.id);
                        if (typeof method !== 'undefined') {
                            this.setDelivery(method)
                        }
                    }
                }

            })
        },
        toggleAllSelect() {
            this.orders = this.orders.map((order) => {
                order.checked = this.toggleSelect;
                return order
            })
        },
        checkServiceHasUploads(service, order) {

            if (!service.is_photo) {
                return ''
            }
            let result = 'no-uploaded-pictures';

            if (!Array.isArray(this.account.parcels_pictures_counts)) {
                return result
            }

            if (!this.account.parcels_pictures_counts.length) {
                return result
            }

            let data = this.account.parcels_pictures_counts.find(element => element.parcel_id === order.id);

            if (typeof data === 'undefined') {
                return result;
            }

            if (!data.cnt) {
                return result
            }
            return 'has-uploaded-pictures';

        },
        checkPromoCode() {
            if (this.promo_code.code === '') {
                this.errors = {
                    promo_code: [this.get_translation_constant('text_field_is_required')]
                }
                return false;
            }

            axios.post(this.promocodecheckurl, {promo_code: this.promo_code.code}).then(response => {
                if (response.status === 200) {
                    this.isValidPromo = true;
                    this.promo_code.text = response.data.message;
                    delete this.errors.promo_code;
                }
            }).catch(error => {

                if (typeof error.response.status !== 'undefined') {
                    if (error.response.status === 400) {
                        this.errors = {
                            promo_code: [this.get_translation_constant('text_promo_code_fails')]
                            //promo_code: [error.response.data.errors.message]
                        }
                        this.isValidPromo = false;
                    }

                    if (error.response.status === 422) {
                        this.errors = {
                            promo_code: [this.get_translation_constant('text_promo_code_fails')]
                            //  promo_code: [error.response.data.errors.message]
                        }
                        this.isValidPromo = false;
                    }
                    if (error.response.status === 500) {
                        this.errors = {
                            promo_code: [this.get_translation_constant('text_promo_code_fails')]
                            //promo_code: [error.response.data.errors.message]
                        }
                        this.isValidPromo = false;
                    }
                }

            });
        },

        getPromoCodeText() {
            return this.get_translation_constant('text_promo_code_success') + ' ' + this.promo_code.text
        },

        handleCloseShipping() {
            if (this.form.deliveryMethod.pre_save !== 'undefined' && this.form.deliveryMethod.pre_save) {
                if (confirm(this.get_translation_constant('text_pre_save_shipping'))) {
                    this.preSaveDelivery();
                    console.log('shipping saved');
                }
            }
            this.orderShippingModal.modal('hide');
        },

        asyncFind(query) {
            axios.post(this.novaposhtastreetsearchlink, {
                street_ref: this.form.deliveryMethod.novaPoshta.city.id,
                find_street: query
            }).then(response => {
                this.form.deliveryMethod.novaPoshta.streets = response.data
            });
        },
        searchTimeOut(query) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
                this.searchChange = false;
            }
            this.searchChange = true;
            this.timer = setTimeout(() => {
                this.asyncFind(query)
            }, 1000);
        },
        asyncFindWarehouse(query) {
            axios.post(this.novaposhtawarehousessearchlink, {
                city_ref: this.form.deliveryMethod.novaPoshta.city.id,
                find_string: query
            }).then(response => {
                this.form.deliveryMethod.novaPoshta.warehouses = response.data
            });
        },
        searchTimeOutWarehouse(query) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
                this.searchChange = false;
            }
            this.searchChange = true;
            this.timer = setTimeout(() => {
                this.asyncFindWarehouse(query)
            }, 1000);
        },

        asyncCities(query) {
            if (query === '') {
                return;
            }
            axios.post(this.novaposhtacitysearchlink, {
                find_city: query
            }).then(response => {
                this.form.deliveryMethod.novaPoshta.cities = response.data
            });
        },
        searchCities(query) {
            if (query === '') {
                return;
            }
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
                this.searchChange = false;
            }
            this.searchChange = true;
            this.timer = setTimeout(() => {
                this.asyncCities(query)
            }, 1000);
        },

        loadStreetsOrWarehouses() {
            console.log('selected')

            setTimeout(() => {
                if (this.form.deliveryMethod.shipping_type_id === 3) {

                    console.log(this.form.deliveryMethod.novaPoshta.city);
                    axios.post(this.novaposhtastreetsearchlink, {
                        street_ref: this.form.deliveryMethod.novaPoshta.city.Ref,
                        find_street: ''
                    }).then(response => {
                        this.form.deliveryMethod.novaPoshta.streets = response.data
                    });
                }
                if (this.form.deliveryMethod.shipping_type_id === 4) {
                    console.log(this.form.deliveryMethod.novaPoshta.city);
                    axios.post(this.novaposhtawarehousessearchlink, {
                        city_ref: this.form.deliveryMethod.novaPoshta.city.Ref,
                    }).then(response => {
                        this.form.deliveryMethod.novaPoshta.warehouses = response.data
                    });
                }
            }, 500)
        },


        updateNames(selectedOption, id) {
            //if ukraine
            if (this.account.location_id === 1) {
                let agent = this.account.agents.find((item) => item.id = selectedOption.id)

                if (typeof agent !== 'undefined') {
                    this.form.deliveryMethod.first_name = agent.first_name
                    this.form.deliveryMethod.last_name = agent.last_name
                    this.form.deliveryMethod.middle_name = agent.patronymic
                }
            }

        }

    },
    computed: {
        modalTitle() {
            return this.modal.title
        },
        modalMessage() {
            return this.modal.message
        },
        modalType() {
            return this.modal.type
        },
        modalId() {
            return this.modal.id
        },
        filteredPaymentMethods() {
            return this.paymentmethods;
            /*
            return this.paymentmethods.filter((payment) => {
                //balance
                //TODO check if NaN, etc
                if (payment.payment_type.id === 1) {
                    return parseFloat(this.order.total_price) <= parseFloat(this.account.balance);
                    //bonus
                } else if (payment.payment_type.id === 2) {
                    return parseFloat(this.order.total_price) <= parseFloat(this.account.bonus);
                } else return true;
            }) */
        },
        deliveryMethodsWithDefault() {
            const delivery = [{
                id: 0,
                title: this.get_translation_constant('text_choose_delivery_method')
            }]
            return [delivery, ...this.deliverymethods]
        },
        estimateText() {
            return this.form.deliveryMethod?.city?.estimate_text;
        },
        deliveryValidated() {
            let method = this.deliverymethods.find(item => item.id === this.form.deliveryMethod.id);
            return (this.form.deliveryMethod.id !== 'undefined') &&
                (typeof method !== 'undefined') &&
                (method.cities.length === 0 ||
                    (method.cities.length > 0) &&
                    (typeof this.form.deliveryMethod.city !== 'undefined') &&
                    (this.form.deliveryMethod.city !== null) &&
                    // (this.form.agent !== null) &&
                    // (this.form.agent.id !== 0) &&
                    (this.form.deliveryMethod.address !== '')
                )
        },
        calculatedOrdersTotalSum() {
            let sum = 0;
            this.orders.map((order) => {
                if (!!order.checked && !order.paid)
                    sum += order.total_price;
            });
            return sum.toFixed(2) + ' $';

        },
        canPay() {
            let sum = 0;
            this.orders.map((order) => {
                sum += order.total_price;
            })
            if (sum <= this.account.balance) {
                return true
            }
            return sum <= this.account.bonus;
        },

        checkFunds() {
            let sum = 0;
            this.orders.map((order) => {
                sum += order.total_price;
            })
            if (this.form.paymentMethod === null) {
                return false
            }
            //check for balance
            if (this.form.paymentMethod.payment_type.id === 1) {
                return this.account.balance < sum;
            }
            //check for bonus
            if (this.form.paymentMethod.payment_type.id === 2) {
                return this.account.bonus < sum;
            }
            return false;
        },
        someOrderIsNotPaid() {
            if (this.orders.length === 0) {
                return false
            }
            return this.orders.some((order) => (!!order.paid === false) && !!order.checked);
        },
        someOrderIsPaid() {
            if (this.orders.length === 0) {
                return false
            }
            return this.orders.some((order) => (!!order.paid === true) && !!order.checked && ((order.shipping_info === null) || ((order.shipping_method !== null) && (order.shipping_method.pre_save))));
        },
        checkedNotPaidOrders() {
            return this.orders.filter((order) => (!!order.paid === false) && !!order.checked);
        },
        checkedPaidNotShippedOrders() {
            return this.orders.filter((order) => (!!order.paid === true) && !!order.checked && ((order.shipping_info === null) || ((order.shipping_method !== null) && (order.shipping_method.pre_save))));
        },
        preparedNotifications() {
            if (typeof this.account.notifications === 'undefined' || this.account.notifications === null) {
                return []
            }
            return this.account.notifications;
        },
        warehouseList() {
            return this.form.deliveryMethod.novaPoshta.warehouses;
        },
        agentList() {
            if (this.account.agents.length < 1) {
                return []
            }
            let result = this.account.agents.filter((agent) => !agent.is_busy).map((agent) => {
                return {
                    id: agent.id,
                    name: agent.first_name_latin + ' ' + agent.last_name_latin
                }
            })
            return [{id: '', name: ''}, ...result]
        },
    },
    created() {
        this.orders = this.account.parcels.map((order) => {
            order.checked = false;
            return order
        });

        this.locationPrefixes = Object.values(this.locations.filter((location) => {
            return location.id === this.account.location_id
        })).map((location) => {
            return {
                image: location.image,
                title: location.phone_prefix
            };
        })
        this.form.phone_prefix = this.locationPrefixes[0]
        this.localAccount = this.account;
    },
    mounted() {
        this.initModals();
        // axios.post(this.novaposhtausersearchlink, this.form.deliveryMethod).then(response => {
        //     console.log(response)
        //     this.novaPoshta = response.data.items;
        // }).catch(error => {
        //     console.log(error)
        // });


    },
    watch: {
        'form.paymentMethod': {
            handler(val) {
                if (val === null) {
                    this.errors = {paymentMethod: ["error"]};
                } else {
                    let sum = 0;
                    this.orders.map((order) => {
                        if ((!!order.paid === false) && !!order.checked) {
                            sum += order.total_price;
                        }
                    })
                    if ((val.payment_type.id === 1) && (this.account.balance < sum) ||
                        (val.payment_type.id === 2) && (this.account.bonus < sum)) {
                        this.errors = {paymentMethod: ["error"]};
                    } else {
                        this.errors = [];
                    }
                }
            }
        },
        'orders': {
            handler(val) {
                if (val.some((order) => {
                    return order.checked === false
                })) {
                    this.toggleSelect = false;
                }
            },
            deep: true
        },
        'form.deliveryMethod': {
            handler(val) {
                /*
                let shippingCost = 0;
                if ((typeof val.city !== 'undefined') && (val.city !== null)) {
                    if (isNaN(parseFloat(val.city.price)) || isNaN(parseFloat(val.price))) {
                        this.errors['shippingMethodCostError'] = ['error'];
                    }
                    shippingCost = parseFloat(val.city.price) > parseFloat(val.price) ?
                        parseFloat(val.city.price).toFixed(2) : parseFloat(val.price).toFixed(2)
                }
                if (this.account.balance < shippingCost) {
                    this.errors['shippingMethodCostError'] = ['error'];
                }
                * */

            },
            deep: true
        },
        'trigger.successPayment': {
            handler(val) {
                if (!val) {
                    console.log(val)
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
